<template>
    <rkm-area
        class="pb-1"
        title="Testes rápidos"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col
                v-for="(testeRapido, index) in data.form.posConsulta.testesRapidos"
                :key="index"
                class="mb-2"
                cols="6"
            >
                <rkm-list-group>
                    <rkm-list-group-item class="rkm-list-group-item">
                        <rkm-row>
                            <rkm-col
                                class="align-self-center"
                                cols="12"
                            >
                                <rkm-form-checkbox
                                    :value="testeRapido.id"
                                    @change.native="handleTesteRapidoChange"
                                >
                                    {{testeRapido.nome}}
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-list-group-item>
                </rkm-list-group>

                <rkm-collapse
                    :visible="!!data.model.posConsulta.testesRapidos.find(t => t.id === testeRapido.id)"
                    class="rkm-collapse"
                >
                    <rkm-row class="p-2">
                        <rkm-col cols="12">
                            <rkm-form-textarea
                                v-if="data.model.posConsulta.testesRapidos.find(t => t.id === testeRapido.id)"
                                :validations="validations.resultado"
                                placeholder="Resultado"
                                rows="6"
                                v-model="data.model.posConsulta.testesRapidos.find(t => t.id === testeRapido.id).resultado"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-collapse>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    computed: {
        validations() {
            return {
                resultado: {max: 500},
            }
        },
    },
    methods: {
        handleTesteRapidoChange(event) {
            const testeRapido = this.data.form.posConsulta.testesRapidos.find(testeRapido => testeRapido.id === parseInt(event.target.value))

            if (event.target.checked) {
                this.data.model.posConsulta.testesRapidos.push({
                    id: parseInt(event.target.value),
                    resultado: null,
                })
            } else {
                this.data.model.posConsulta.testesRapidos.splice(this.data.model.posConsulta.testesRapidos.findIndex(testeRapido => testeRapido.id === parseInt(event.target.value)) , 1)
            }

            if (testeRapido.codigo) {
                this.$emit('testeRapidoChange', {
                    checked: event.target.checked,
                    codigo: testeRapido.codigo,
                })
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>

<style scoped>
.rkm-list-group-item {
    padding: 0.75rem 1.25rem;
}
.rkm-list-group-item:focus {
    outline: none;
}
.rkm-list-group-item:first-child {
    border-radius: 0;
}
.rkm-list-group-item:last-child {
    border-radius: 0;
}
.rkm-list-group-item > .row {
    margin: 0;
}
.rkm-collapse {
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    border-left: 1px solid rgba(0, 0, 0, .15);
    border-right: 1px solid rgba(0, 0, 0, .15);
}
</style>